import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import {
  deleteCostCenterGrantByGroup,
  editCostCenterGrantByGroup
} from 'RestAPIs/admin';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useGetCostCenters } from '../../../../../../../../../queries';
import { useGetCostCenterGrantsByGroup } from '../../../../../hooks/queries';
import DataPermissionsInner from './components/DataPermissionsInner';

import type { AxiosResponse } from 'axios';
import type { FC } from 'react';
import type { TabProps } from '../../types';

const schema = yup.object({
  costCenterGrants: yup
    .array()
    .of(
      yup.object().shape({
        approveHours: yup.boolean(),
        brId: yup.number().required()
      })
    )
    .default([{}])
});

const DataPermissions: FC<TabProps> = ({
  setIsNavigationDisabled,
  rows,
  toggleInnerLayout,
  currentViewData,
  setCurrentViewData,
  setIsDirty
}) => {
  'use memo';

  const { data: costCenters } = useGetCostCenters();
  const [deletedIds, setDeletedIds] = useState<number[]>([]);

  const { data: costCenterGrants, isFetching } = useGetCostCenterGrantsByGroup(
    currentViewData.groupId
  );

  const methods = useForm({
    defaultValues: schema.cast({ costCenterGrants: [] }),
    resolver: yupResolver(schema)
  });

  useEffect(() => {
    if (costCenterGrants) {
      methods.reset(schema.cast({ costCenterGrants: costCenterGrants }));
    }
  }, [costCenterGrants, currentViewData, methods]);

  const handleSubmit = (data) => {
    if (data.costCenterGrants) {
      const requestsArray: Promise<AxiosResponse>[] = [];
      data.costCenterGrants
        .filter((value) => value.isCommitted)
        .forEach((detail) => {
          requestsArray.push(
            editCostCenterGrantByGroup(
              currentViewData.groupId,
              detail.brId,
              detail
            )
          );
        });
      deletedIds.forEach((id) => {
        requestsArray.push(
          deleteCostCenterGrantByGroup(currentViewData.groupId, id)
        );
      });

      return Promise.all(requestsArray).catch((error) =>
        showErrorSnackbar(error)
      );
    }

    return Promise.resolve();
  };

  const handleOnCancel = () => {
    setDeletedIds([]);
    methods.reset();
  };

  return (
    <DataPermissionsInner
      setIsNavigationDisabled={setIsNavigationDisabled}
      toggleInnerLayout={toggleInnerLayout}
      rowData={currentViewData}
      rows={rows}
      methods={methods}
      onSubmit={handleSubmit}
      currentViewData={currentViewData}
      setCurrentViewData={setCurrentViewData}
      costCenterGrants={costCenterGrants}
      isFetching={isFetching}
      costCenters={costCenters}
      setDeletedIds={setDeletedIds}
      onCancel={handleOnCancel}
      setIsDirty={setIsDirty}
    />
  );
};

export default DataPermissions;
